import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { EmptyPage } from "../../assets/images";
import {
  DeleteIdPasswordManagerPayloadType,
  GetIdPasswordManagerListPayloadType,
} from "../../commonTypes/stcoToolsType";
import { SearchIcon } from "../../components/Icon";
import IdPasswordManagerTable from "../../components/StcoTools/IdPasswordManager/IdPasswordManagerTable/IdPasswordManagerTable";
import {
  CommonHeader,
  ConfirmationModal,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
} from "../../components/commons";
import InfiniteLoader from "../../components/commons/InfiniteLoader/InfiniteLoader";
import { ID_PASSWORD_MANAGER_HEADERS } from "../../constant/tableHeadersConstants/stcoTools/idPasswordManagerTableHeader";
import useDebounce from "../../customHooks/useDebounce";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { getAllFinacUsersAction, getAssignedClientsToUserAction, resetSession } from "../../redux/auth";
import { AssignedClientsToUserType, FinacUsersType, LoginResponseType } from "../../redux/auth/authTypes";
import { RootState } from "../../redux/rootReducers";
import {
  deleteIdPasswordManagerAction,
  getIdPasswordManagerListAction,
  resetIdPasswordManagerError,
  resetIdPasswordManagerList,
  resetIdPasswordManagerMessage,
  resetIdPasswordManagerSuccess,
  resetTotalUserCountList,
} from "../../redux/stcoTools";
import {
  IdPasswordManagerListType,
  SelectedFilterType,
} from "../../redux/stcoTools/stcoToolsType";
import IdPasswordFilter from "../../components/StcoTools/IdPasswordManager/IdPasswordFilter/IdPasswordFilter";
import { ClientListType } from "../Scheduling/ScheduleReports/ClientVsUserScheduling";
import { UserListType } from "../../components/DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
import { GetAllFinacUserPayloadType, GetAssignedClientsToUserPayloadType } from "../../commonTypes/authTypes";
import { OptionsType } from "../../commonTypes/universalTypes";

type AppProps = {
  history: any;
  token: string | null;
  message: string | null;
  error: string | null;
  success: number | null;
  totalCount: number | null | undefined;
  statusCode: number | null;
  fetching: boolean;
  loginData: LoginResponseType;
  userFetching: boolean;
  totalClientCount: any;
  finacUsersList: [] | FinacUsersType[] | any;
  idPasswordManagerList: [] | IdPasswordManagerListType[];
  dispatchResetSession: () => void;
  dispatchResetIdPasswordManagerError: () => void;
  dispatchResetIdPasswordManagerSuccess: () => void;
  dispatchIdPasswordManagerListAction: (
    data: GetIdPasswordManagerListPayloadType
  ) => void;
  dispatchDeleteIdPasswordManagerAction: (
    data: DeleteIdPasswordManagerPayloadType
  ) => void;
  dispatchResetIdPasswordManagerList: () => void;
  dispatchResetIdPasswordManagerMessage: () => void;
  dispatchResetTotalUserCountList: () => void;
  assignedClientsToUserList: AssignedClientsToUserType[] | [];
  assignedClientsToUserFetching: boolean;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => void;
};

const IdPasswordManagerList = ({
  history,
  token,
  success,
  statusCode,
  error,
  message,
  fetching,
  loginData,
  totalCount,
  idPasswordManagerList,
  dispatchIdPasswordManagerListAction,
  dispatchResetIdPasswordManagerList,
  dispatchResetSession,
  dispatchResetIdPasswordManagerError,
  dispatchResetIdPasswordManagerSuccess,
  dispatchDeleteIdPasswordManagerAction,
  dispatchResetIdPasswordManagerMessage,
  dispatchResetTotalUserCountList,
  dispatchGetAssignedClientsToUserAction,
  dispatchGetAllFinacUsersAction,
  assignedClientsToUserList,
  assignedClientsToUserFetching,
  userFetching,
  totalClientCount,
  finacUsersList,
}: AppProps) => {
  const persistUserSelected = history?.location?.state?.userSelected;
  const persistCategorySelected = history?.location?.state?.selectCategory;
  const persistClientSelected = history?.location?.state?.clientSelected;
  const persistSearchData = history?.location?.state?.searchData;
  const persistFileAttachmentStatus = history?.location?.state?.fileAttachmentStatus
  const [searchData, setsearchData] = useState(
    persistSearchData ? persistSearchData : ""
  );
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [deleteIdPasswordId, setDeleteIdPasswordId] = useState<number>(0);
  const [idPasswordManagerListData, setIdPasswordManagerListData] =
    useState<any>([]);
  const [remove, setRemove] = useState<boolean>(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [searchClear, setSearchClear] = useState(false);
  const [clientSelected, setClientSelected] = useState<ClientListType>({
    value: null,
    label: "Select Client...",
  });
  const [clientOffset, setClientOffset] = useState<number>(0);
  const [finalClientList, setFinalClientList] = useState<ClientListType[] | []>(
    []
  );
  const [finalUserList, setFinalUserList] = useState<UserListType[] | []>([]);
  const [filter, setFilter] = useState<boolean>(false);
  const [text, setText] = useState("");
  const [userText, setUserText] = useState("");
  const [loadCondition, setLoadCondition] = useState(true);
  const [finacApiCall, setFinacApiCall] = useState(false);
  const [userOffset, setUserOffset] = useState(0);
  const [selectCategory, setSelectCategory] = useState<OptionsType>({
    value: null,
    label: "Select Category...",
  });
  const [userSelected, setUserSelected] = useState<ClientListType>({
    value: null,
    label: "Select User...",
  });
  const isFilterSelected = useRef<SelectedFilterType>({
    client: persistClientSelected?.value ? true : false,
    user: persistUserSelected?.value ? true : false,
    category: persistCategorySelected?.value ? true : false,
    fileAttachment:persistFileAttachmentStatus ? true:false
  });
  const [isApiCall, setIsApiCall] = useState(false);

  const [fileAttachmentStatus, setFileAttachmentStatus] = useState("");
  const [fileAttachementStatusValue, setfileAttachmentStatusValue] =
    useState<any>("");

  //====================User Management=============================
  const [isEditIdPasswordManagerPresent, setIsEditIdPasswordManagerPresent] =
    useMenuCheck();
  const [isAddIdPasswordManagerPresent, setIsAddIdPasswordManagerPresent] =
    useMenuCheck();
  const [isIdPasswordManagerListPresent, setIsIdPasswordManagerListPresent] =
    useMenuCheck();
  //=================================================================
  useEffect(() => {
    dispatchResetIdPasswordManagerList();
    dispatchResetIdPasswordManagerError();
    dispatchResetIdPasswordManagerSuccess();
    dispatchResetIdPasswordManagerMessage();
    dispatchResetTotalUserCountList();
    setIsEditIdPasswordManagerPresent("Edit ID/Password", "menu");
    setIsAddIdPasswordManagerPresent("Add ID/Password", "menu");
    setIsIdPasswordManagerListPresent("ID Password Manager List", "menu");
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (token && idPasswordManagerList?.length && totalCount) {
      setIsApiCall(true);
      let finalData = {
        token,
        limit: limit,
        offset,
        searchData: searchData ? searchData : persistSearchData,
        clientCode: clientSelected?.value
          ? clientSelected?.value
          : persistClientSelected?.value,
        category: selectCategory?.value
          ? selectCategory?.value
          : persistCategorySelected?.value,
        accessMemberId: userSelected?.value
          ? userSelected?.value
          : persistUserSelected?.value,
      attachments:fileAttachementStatusValue === 1 || fileAttachementStatusValue === 0
      ? fileAttachementStatusValue
      : persistFileAttachmentStatus,
        
      };
      if (offset < totalCount) {
        dispatchIdPasswordManagerListAction(finalData);
    
      }
    } else if (offset === 0) {
      let finalData = {
        token,
        limit: limit,
        offset,
        searchData: searchData ? searchData : persistSearchData,
        clientCode: clientSelected?.value
          ? clientSelected?.value
          : persistClientSelected?.value,
        category: selectCategory?.value
          ? selectCategory?.value
          : persistCategorySelected?.value,
        accessMemberId: userSelected?.value
          ? userSelected?.value
          : persistUserSelected?.value,
      attachments:fileAttachementStatusValue === 1 || fileAttachementStatusValue === 0
      ? fileAttachementStatusValue
      : persistFileAttachmentStatus,
     

      };
      dispatchIdPasswordManagerListAction(finalData);


    }
    //eslint-disable-next-line
  }, [offset]);




  useEffect(() => {
    if (
      persistUserSelected?.value ||
      persistCategorySelected?.value ||
      persistClientSelected?.value ||
      persistFileAttachmentStatus
    ) {
      setFilter(true);
      if (persistCategorySelected?.value) {
        setSelectCategory(persistCategorySelected);
      }
      if (persistUserSelected?.value) {
        setUserSelected(persistUserSelected);
      }
      if (persistClientSelected?.value) {
        setClientSelected(persistClientSelected);
      }
      if(persistFileAttachmentStatus){
        setfileAttachmentStatusValue(persistFileAttachmentStatus)
      }
      setOffset(0);
    }
  }, [persistUserSelected, persistCategorySelected, persistClientSelected,persistFileAttachmentStatus]);

  useEffect(() => {
    if (remove) {
      const finaldata = {
        token,
        clientCode: clientSelected?.value,
        category: selectCategory?.value,
        accessMemberId: userSelected?.value,
        attachments:fileAttachementStatusValue

      };

      dispatchIdPasswordManagerListAction(finaldata);


    }
    //eslint-disable-next-line
  }, [remove]);

  //infinite Scroll
  const onScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight) {
      setOffset(offset + limit);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    //eslint-disable-next-line
  }, [idPasswordManagerList]);

  const fetchNewData = (search: string) => {
    if (token) {
      let finalData = {
        token,
        offset,
        limit,
        searchData: search,
        clientCode: clientSelected?.value
          ? clientSelected?.value
          : persistClientSelected?.value,
        category: selectCategory?.value
          ? selectCategory?.value
          : persistCategorySelected?.value,
        accessMemberId: userSelected?.value
          ? userSelected?.value
          : persistUserSelected?.value,
      //     attachments:
      // fileAttachementStatusValue !== undefined && fileAttachementStatusValue !== null
      //   ? fileAttachementStatusValue
      //   : persistFileAttachmentStatus,
      attachments:fileAttachementStatusValue === 1 || fileAttachementStatusValue === 0
      ? fileAttachementStatusValue
      : persistFileAttachmentStatus,
       

      };

      if (token) {
        setSearchClear(true);

        if (offset === 0) {
          dispatchIdPasswordManagerListAction(finalData);


          
          setOffset(0);
        } else {
          setOffset(0);
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    //eslint-disable-next-line
  }, [idPasswordManagerList]);

  useEffect(() => {
    if (assignedClientsToUserList?.length) {
     
        let finalClientData = assignedClientsToUserList?.map((e: any) => {
          return {
            value: e?.client_code,
            label: `(${e?.client_code}) ${e?.company_name}`,
          };
        });
          setFinalClientList([...finalClientData]);
    }
    //eslint-disable-next-line
  }, [assignedClientsToUserList]);


  const fetchClientNewData = () => {
    setClientOffset(0);
    if (token) {
  
      let params = {
        token,
        srch_value: text
      };
      dispatchGetAssignedClientsToUserAction(params)
    }
  };

  useDebounce(
    () => {
      fetchClientNewData();
    },
    500,
    [text]
  );

  const handleChangeClient = (client: any) => {
    setClientSelected(client);
  };

  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setClientOffset((prv) => prv + limit);
  };

  const checkUserBottom = (e: any) => {
    setLoadCondition(false);
    setUserOffset((prv) => prv + limit);
  };

  const handleCategoryChange = (e: any) => {
    setSelectCategory(e);
  };

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: userOffset,
        limit,
        user_type: "stco_users",
        status: 1,
        search_term: userText,
      };
      if (offset <= finacUsersList?.total_count && finacApiCall) {
        dispatchGetAllFinacUsersAction(finalUserData);
      }
    }
    //eslint-disable-next-line
  }, [userOffset]);

  const fetchNewUserData = (search: string) => {
    const finalData = {
      token,
      offset: userOffset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: userText,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  // Custom debounce hook for search data
  useDebounce(
    () => {
      if (userText) {
        fetchNewUserData(userText);
      } else {
        setFinacApiCall(true);
        const finalData = {
          token,
          offset: 0,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: userText,
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [userText]
  );

  useEffect(() => {
    if (idPasswordManagerList?.length === 0) {
      setIdPasswordManagerListData(idPasswordManagerList);
    } else if (offset > 0 && idPasswordManagerList?.length > 0) {
      setIdPasswordManagerListData((prv: any) => [
        ...prv,
        ...idPasswordManagerList,
      ]);
    } else {
      setIdPasswordManagerListData(idPasswordManagerList);
    }
    //eslint-disable-next-line
  }, [idPasswordManagerList]);

  // Custom debounce hook for search data
  useDebounce(
    () => {
      if (isApiCall) {
        if (searchData) {
          fetchNewData(searchData);
        } else {
          delete  history?.location?.state?.searchData
          let finalData = {
            token,
            offset,
            limit,
            searchData: "",
            clientCode: clientSelected?.value,
            category: selectCategory?.value,
            accessMemberId: userSelected?.value,
            attachments:fileAttachementStatusValue

          };
          if (searchData?.length === 0) {
            dispatchIdPasswordManagerListAction(finalData);


            setOffset(0);
          }
        }
      }
    },
    500,
    [searchData]
  );

  useEffect(() => {
    if (finacUsersList?.data?.length) {
      const data = finacUsersList?.data?.filter(
        (e: any) => e.user_id !== loginData?.user_id
      );
      let finalUserData = data?.map((user: FinacUsersType) => {
        return {
          value: user?.user_id,
          label: `${user?.first_name} ${user?.last_name}`,
          image: user?.profile_pic?.file_url,
        };
      });
      if (userOffset > 0) {
        setFinalUserList([...finalUserList, ...finalUserData]);
      } else {
        setFinalUserList([...finalUserData]);
      }
    }
    //eslint-disable-next-line
  }, [finacUsersList]);

  const handleSearch = (e: any) => {
    setsearchData(e.target.value);
  };

  const handleEditIdPasswordData = (data: any) => {
    history.push({
      pathname: `/id-password-manager/edit`,
      state: { data, clientSelected, userSelected, selectCategory, searchData , fileAttachementStatusValue},
    });
  };


  const handleShowConfirmationModal = (id: number) => {
    setShowConfirmationModal(!showConfirmationModal);
    setDeleteIdPasswordId(id);
  };

  const deleteIdPasswordRecord = (record_id: number) => {
    let data = {
      record_id,
      token,
    };
    dispatchDeleteIdPasswordManagerAction(data);
    setRemove(true);
  };

  const handleFilter = (type?: string) => {
    dispatchResetIdPasswordManagerList();
    setIdPasswordManagerListData([]);
    if (type != "clear") {
      setFilter(true);
    } else {
      delete history?.location?.state?.userSelected;
      delete history?.location?.state?.selectCategory;
      delete history?.location?.state?.clientSelected;
      delete history?.location?.state?.fileAttachmentStatus
    }

    let finalData = {
      token,
      offset,
      limit,
      searchData,
      clientCode: type === "clear" ? null : clientSelected?.value,
      category: type === "clear" ? null : selectCategory?.value,
      accessMemberId: type === "clear" ? null : userSelected?.value,
      attachments: type === "clear" 
      ? null 
      : fileAttachementStatusValue !== undefined && fileAttachementStatusValue !== null
        ? fileAttachementStatusValue 
        : null,

    };

    if (token) {
      if (offset === 0) {
        dispatchIdPasswordManagerListAction(finalData);


      } else {
        setOffset(0);
      }
    }
  };

  const handleUserChange = (e: any) => {
    setUserSelected(e);
  };

  const onMenuClose = () => setLoadCondition(true);

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetIdPasswordManagerError();
            }}
          />
        );
      }
    } else if (
      success === 1 &&
      message?.includes("Record deleted succesfully!")
    ) {
      dispatchResetIdPasswordManagerSuccess();
    }

    return false;
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader title={`Id Password Manager`} />
        </div>
        {isAddIdPasswordManagerPresent && (
          <div className="col-md-6">
            <div className="d-flex flex-row justify-content-end mr-5">
              {idPasswordManagerList?.length && (
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    history.push({
                      pathname: `/id-password-manager/add`,
                      state: {
                        clientSelected: undefined,
                        userSelected: undefined,
                        selectCategory: undefined,
                        searchData: undefined,
                        fileAttachementStatusValue: undefined
                      },
                    })
                  }
                >
                  + Add ID/Password
                </button>
              )}
            </div>
          </div>
        )}
      </div>
      {isIdPasswordManagerListPresent && (
        <div className="new-table-card mt-3">
          <div className="header">
            <div className="left-header">
              <div className="heading mb-0">Id Password Manager List</div>
              <div className="sub-heading">{`Total ${
                totalCount ? totalCount : 0
              } entries found`}</div>
            </div>
            <div className="right-header">
              <div className="col-md-12 position-relative">
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e: any) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchData}
                />
              </div>

              <IdPasswordFilter
                type="sideBar"
                clientSelected={clientSelected}
                finalClientList={finalClientList}
                handleChangeClient={handleChangeClient}
                checkBottom={checkBottom}
                checkUserBottom={checkUserBottom}
                assignedClientsToUserFetching={assignedClientsToUserFetching}
                onMenuClose={onMenuClose}
                setText={setText}
                setOffset={setClientOffset}
                loadCondition={loadCondition}
                setLoadCondition={setLoadCondition}
                handleFilter={handleFilter}
                setClientSelected={setClientSelected}
                setUserSelected={setUserSelected}
                filter={filter}
                setFilter={setFilter}
                userFetching={userFetching}
                userSelected={userSelected}
                finalUserList={finalUserList}
                handleUserChange={handleUserChange}
                setUserText={setUserText}
                setUseroffset={setUserOffset}
                selectCategory={selectCategory}
                setSelectCategory={setSelectCategory}
                handleCategoryChange={handleCategoryChange}
                isFilterSelected={isFilterSelected}
                fileAttachmentStatus={fileAttachmentStatus}
                setFileAttachmentStatus={setFileAttachmentStatus}
                fileAttachementStatusValue={fileAttachementStatusValue}
                setfileAttachmentStatusValue={setfileAttachmentStatusValue}
              />
            </div>
          </div>
          {!idPasswordManagerList?.length && !fetching ? (
            <div className="mt-5">
              <EmptyListPage
                title="No Id Password Manager List Found!"
                text={
                  isAddIdPasswordManagerPresent
                    ? "Start adding Id Password by clicking the button below"
                    : ""
                }
                showAddButton={isAddIdPasswordManagerPresent}
                image={EmptyPage}
                imageWidth="30%"
                buttonTitle="+ Add ID/Password"
                onButtonClick={() =>
                  history?.push({
                    pathname: `/id-password-manager/add`,
                    state: {
                      clientSelected: undefined,
                      userSelected: undefined,
                      selectCategory: undefined,
                      searchData: undefined,
                      fileAttachementStatusValue: undefined
                    },
                  })
                }
              />
            </div>
          ) : (
            <IdPasswordManagerTable
              offset={offset}
              fetching={fetching}
              loginData={loginData}
              deleteIdPasswordRecord={deleteIdPasswordRecord}
              handleShowConfirmationModal={handleShowConfirmationModal}
              tableHeaders={ID_PASSWORD_MANAGER_HEADERS}
              idPasswordManagerList={idPasswordManagerListData}
              handleEditIdPasswordData={handleEditIdPasswordData}
              isEditIdPasswordManagerPresent={isEditIdPasswordManagerPresent}
            />
          )}
        </div>
      )}
      {showConfirmationModal && (
        <ConfirmationModal
          toggle={() => {
            handleShowConfirmationModal(deleteIdPasswordId);
          }}
          isOpen={showConfirmationModal}
          title={"Delete Id Password Record"}
          message={`Are you sure? you want to Delete`}
          confirmButtonText={"Delete"}
          onPressConfirm={() => {
            deleteIdPasswordRecord(deleteIdPasswordId);
            handleShowConfirmationModal(deleteIdPasswordId);
          }}
        />
      )}
      {offset == 0 && fetching && <Loader />}
      {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  message: state.stcoTools.message,
  success: state.stcoTools.success,
  error: state.stcoTools.error,
  statusCode: state.stcoTools.statusCode,
  fetching: state.stcoTools.fetching,
  idPasswordManagerList: state.stcoTools.getidPasswordManagerList,
  loginData: state.auth.loginData,
  totalCount: state.stcoTools.totalUserCountList,
  userFetching: state.auth.fetching,
  finacUsersList: state.auth.finacUsersList,
  totalClientCount: state.clientDirectory.totalCount,
  assignedClientsToUserList: state.auth.assignedClientsToUserList,
  assignedClientsToUserFetching: state.auth.fetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetIdPasswordManagerSuccess: () =>
    dispatch(resetIdPasswordManagerSuccess()),
  dispatchResetIdPasswordManagerError: () =>
    dispatch(resetIdPasswordManagerError()),
  dispatchIdPasswordManagerListAction: (
    data: GetIdPasswordManagerListPayloadType
  ) => dispatch(getIdPasswordManagerListAction(data)),
  dispatchDeleteIdPasswordManagerAction: (
    data: DeleteIdPasswordManagerPayloadType 
  ) => dispatch(deleteIdPasswordManagerAction(data)),
  dispatchResetIdPasswordManagerList: () =>
    dispatch(resetIdPasswordManagerList()),
  dispatchResetTotalUserCountList: () => dispatch(resetTotalUserCountList()),
  dispatchResetIdPasswordManagerMessage: () =>
    dispatch(resetIdPasswordManagerMessage()),
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => dispatch(getAssignedClientsToUserAction(data)),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IdPasswordManagerList);
